import { NgModule } from '@angular/core';
import { DatePipe } from "@angular/common";
import { SharedModule } from '../shared/shared.module';
import { KnowHowComponent } from './know-how.component';
import { KnowHowContactInfoComponent } from './know-how-contact-info/know-how-contact-info.component';
import { KnowHowMessageModalComponent } from './know-how-message-modal/know-how-message-modal.component';
import { KnowHowDocumentsOverview } from './know-how-documents/know-how-documents-overview/know-how-documents-overview.component';
import { KnowHowDocumentCategoryListComponent } from './know-how-documents/know-how-document-category-list/know-how-document-category-list.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        KnowHowComponent,
        KnowHowContactInfoComponent,
        KnowHowMessageModalComponent,
        KnowHowDocumentsOverview,
        KnowHowDocumentCategoryListComponent
    ],
    exports: [
    ],
    providers: [
        DatePipe
    ]
})
export class KnowHowModule { }
